<!-- <ng-container *ngIf="isLoading$ | async">

</ng-container> -->
<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{'MENU.BLOG' | translate}}</h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.BLOG' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="isLoading$ | async">
    <div class="progress progress-modal">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</ng-container>
<section class="doctors-area doctors-area-two pt-100">
  <div class="container-fluid py-5 px-lg-5">
  <div class="row justify-content-center">
    <div class="col-md-4 col-sm-6 mb-4" *ngFor="let Blog of HospitalBlogs">
      <div class="card team-card text-center shadow border-0 h-100 rounded-4 p-3">
        <img [src]="Blog.image" alt="{{Blog.blogHeaderEn}}" class="team-photo mx-auto mb-3 shadow-sm">
        <h4 class="fw-semibold" style="margin: 20px 0px;">{{ language == 'en' ? Blog.blogHeaderEn : Blog.blogHeaderAr }}</h4>
        <p class="text-body-secondary px-2" style="--tw-text-opacity: 1;color: rgb(147 147 147 / var(--tw-text-opacity))!important;">
            {{ language == 'en' ? Blog.blogDetailsEn : Blog.blogDetailsAr }}</p>
      </div>
    </div>
  </div>
</div>

</section>
<!-- <section class="blog-area-two pt-100">
    <div class="container">
        <div class="row">
            <div *ngFor="let Blog of HospitalBlogs" class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp"
                data-wow-delay=".3s">
                <div class="blog-item">
                    <div class="blog-top">
                        <a *ngIf="Blog.image != null;else Blogimage" (click)="openDialog(Blog)"><img
                                [src]="Blog.image | SafeUrlPipe" alt="Blog"></a>
                        <ng-template #Blogimage><a><img src="assets/img/DefaultImage.png" alt="Blog" height="250px"
                                    width="350px"></a></ng-template>
                    </div>
                    <div class="blog-bottom">
                        <h5 style="color: rgb(182 142 39) !important;">{{ language == 'en'? Blog.blogHeaderEn :
                            Blog.blogHeaderAr}}</h5>
                        <p style="height: 130px;--tw-text-opacity: 1;color: rgb(147 147 147 / var(--tw-text-opacity))!important;"
                            *ngIf="language == 'en'">{{ Blog.blogDetailsEn | truncateWords:20}}</p>
                        <p style="height: 130px;--tw-text-opacity: 1;color: rgb(147 147 147 / var(--tw-text-opacity))!important;"
                            *ngIf="language == 'ar'">{{ Blog.blogDetailsAr | truncateWords:20}}</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->